import SpaRoundedIcon from '@mui/icons-material/SpaRounded'
import PeopleRoundedIcon from '@mui/icons-material/PeopleRounded'

// ==============================|| MENU ITEMS - SAMPLE PAGE & DOCUMENTATION ||============================== //

const support = {
  id: 'services',
  title: 'Services',
  type: 'group',
  children: [
    {
      id: 'residents',
      title: 'Residents',
      type: 'item',
      icon: PeopleRoundedIcon,
      url: '/residents',
      requirements: {
        componentId: 'NavItem__Residents',
        auth: true,
        endpoints: [{ method: 'GET', path: '/user' }]
      }
    },
    {
      id: 'care',
      title: 'Care',
      type: 'item',
      icon: SpaRoundedIcon,
      url: '/care',
      requirements: {
        componentId: 'NavItem__Care',
        auth: true,
        endpoints: [{ method: 'GET', path: '/user' }]
      }
    }
  ]
}

export default support
